'use client'

import { ToolAuthDialog } from '@/components/marketing/tools/tool-auth-dialog'

/** Tool-page auth modal for the Seedance 2.5 studio. See {@link ToolAuthDialog}. */
export function Seedance25AuthDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <ToolAuthDialog
      open={open}
      onOpenChange={onOpenChange}
      description="Create your Soku AI account to generate with Seedance 2.5 early access. You stay right on this page."
    />
  )
}
